import { createContext, useState } from 'react'

export enum StepTypes {
  AddMessageStep = 'AddMessageStep',
  AddDocStep = 'AddDocStep'
}

export const useStep = () => {
  const [step, setStep] = useState(StepTypes.AddMessageStep)

  return { step, setStep }
}

type StepContextType = {
  step: string
  setStep: (step: StepTypes) => void
}

const initialValue = {
  step: StepTypes.AddMessageStep,
  setStep: () => ({})
}

// TODO: Move this into redux instead
export const stepContext = createContext<StepContextType>(initialValue)
